<template>
   <div class="installPage" style="background:#ffd352;min-height: 702px;">
        <div class="bgBox"><img src="./../../../assets/home/bg-top.png" alt=""></div>
        <div class="header">
            <i> </i>
            <span>i红包助手安装页面</span>
        </div> 
        <div class="content">
            <div class="logoBox"><img :src="imgsrc" alt=""></div>
            <div class="firstBox">
                <p class="firstTitle">1</p>
                <p class="firstText">下载安装：{{name}}</p>
                <p class="firstText firstText1" style="color:red;">注：下载完成后请从本页面打开应用，才能进入正常界面</p>

               <a href="javascript:;"  @click="show"><div class="firstBtn" >立即安装</div></a> 
                <!--  <a href="itms-services://?action=download-manifest&url=https://yy-repeat.oss-cn-beijing.aliyuncs.com/static/app/eoscash.plist"  @click="show"><div class="firstBtn" >立即安装</div></a>-->
            </div>
            <div class="thirdBox">
                <p class="thirdTitle">2</p>
                <p class="thirdText">安装成功后，在本页面打开</p>
                <div class="thirdBtn" @click="openApp">打开i红包</div>
            </div>
        <div class="mask" ref="mask"></div>
        <div class="tips" ref="tips"><img src="./../../../assets/newtask/tips.png" alt=""></div>
        </div>
    </div>
</template>


 <style lang="scss" scoped>
 
    .mask{
        width:100%;
        height:100%;
        opacity: 0.6;
        background: #000000;
        display:none;
        position:fixed;
        top:0;
        z-index: 1;
    }
    .tips{
        width:2.25rem;
        height:1rem;
        position:absolute;
        top:.05rem;
        right:.1rem;
        display:none;
        z-index: 2;
    }
    .bgBox{
        width:100%;
        height:2.12rem;
        position: absolute;
        top:0;
    }
    .header{
        width:90%;
        height:.40rem;
        margin-left: 5%;
        display: flex;
        justify-content: center;
        align-items: center;
        position:relative;
        span{
            font-size: .18rem;
            line-height: .40rem;
        }
        i{
            position:absolute;
            left:0.05rem;
            width:.26rem;
            height:.16rem;
            padding-right:.16rem;
        }
    }
    .content{
        display:flex;
        align-items: center;
        flex-direction: column;
        .logoBox{
            width:1.4rem;
            height:1.35rem;
            margin-top:.6rem;
            position:absolute;
            z-index:1;
            top:-0.1rem;
        }
        
        .firstBox{
            position:absolute;
            z-index:1;
            width:3.45rem;
            height:1.75rem;
            background:#fff;
            margin-top:1.7rem;
            border-radius: .06rem;
            display:flex;
            align-items: center;
            flex-direction: column;
            .firstTitle{
                margin-top:.25rem;
                font-size: .18rem;
            }
            .firstText{
                margin-top:.10rem;
                font-size: .14rem;
            }   
            .firstText1{
                margin-top:.10rem;
                font-size: .11rem;
            } 
            .firstBtn{
                margin-top:.20rem;
                font-size: .15rem;
                background-image: linear-gradient(112deg, #FFDF42 0%, #FFEC77 100%);
                border-radius: .18rem;
                width:1.1rem;
                height:.4rem;
                text-align: center;
                line-height: .4rem;
            }
        }
        .secondBox{
            position:absolute;
            z-index:1;
            width:3.45rem;
            height:2.68rem;
            background:#fff;
            margin-top:3.55rem;
            border-radius: .06rem;
            display:flex;
            align-items: center;
            flex-direction: column;
            .secondTitle{
                margin-top:.25rem;
                font-size: .18rem;
            }
            .secondText{
                margin-top:.10rem;
                font-size: .14rem;
            }
            .secondBox{
                width:1.73rem;
                height:1.53rem;
                margin-top:.9rem;
            }
        }
        .thirdBox{
            width:3.45rem;
            height:1.58rem;
            background:#fff;
            margin-top:4rem;
            border-radius: .06rem;
            display:flex;
            align-items: center;
            flex-direction: column;
            margin-bottom: .2rem;
            .thirdTitle{
                margin-top:.25rem;
                font-size: .18rem;
            }
            .thirdText{
                margin-top:.10rem;
                font-size: .14rem;
            }
            .thirdBtn{
                margin-top:.20rem;
                font-size: .15rem;
                background-image: linear-gradient(112deg, #FFDF42 0%, #FFEC77 100%);
                border-radius: .18rem;
                width:1.1rem;
                height:.4rem;
                text-align: center;
                line-height: .4rem;
            }
        }
    }
</style>

<script>
export default {
        data () {
            return {
            imgsrc:'http://img.bjyiyoutech.com/static/applogwhn.jpg',
            url:'',
            name:'小友拼图',
            }
        },
    methods:{
        out(){
            window.location.href = "wwww.baidu.com"
        },
        openApp(){
            if(this.isWeiXin()){
                //如果当前页面是在微信内置浏览器中
                this.$refs.tips.style.display = "block";
                this.$refs.mask.style.display = "block";
            }
            else{
             //window.location.href = "wx1d3c329470764f7d://"
            window.location.href = this.jumpurl
            }
        },
        isWeiXin() {
                var ua = window.navigator.userAgent.toLowerCase();
                if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                    return true;
                }
                else {
                    return false;
                }
            },
        show(){
            if(this.isWeiXin()){
                //如果当前页面是在微信内置浏览器中
                this.$refs.tips.style.display = "block";
                this.$refs.mask.style.display = "block";
            }
            else{
               window.location.href = this.url
            }
            
        } 
    },
    created(){

        let isopen = this.$route.query.isopen
        console.log(9999999999999);
        console.log(isopen);
        
        let _this = this;
        this.$axios.get("/api/index/getappkezi"
        ).then(res=>{
            console.log(res.data)
            _this.url = res.data.url
            _this.jumpurl = res.data.jumpurl
            _this.imgsrc = res.data.imgsrc
            _this.name = res.data.name
            if(res.data.isbj == 1||res.data.isbj=='1'){
               // _this.$router.push({path:"/home/outside/no"})
            }
            if(isopen !=0){
                window.location.href = _this.jumpurl
            }
        })
        
    },
}

/**
 * @description 判断浏览器的隐身(无痕)模式
 */
var isPrivate = false;
try {
window.openDatabase(null, null, null, null);
} catch (_) {
isPrivate = true;
}
console.log(isPrivate)

export function browserIsHide () {
  let fs = window.RequestFileSystem || window.webkitRequestFileSystem;

  if (!fs) {
    console.log("check failed?");
  } else {
    fs(window.TEMPORARY,100,function(){
      console.log('非无痕模式')
    },function(){
    isPrivate = true;
    });
  }
}
browserIsHide ();
/**以下方式判断错误，在无痕模式下，localStorage依旧可以使用*/
if(typeof localStorage === 'object'){
  try{
    localStorage.setItem('localStorage', 1);
    localStorage.removeItem('localStorage');
  }catch(e){
    Storage.prototype._setItem = Storage.prototype.setItem;
    Storage.prototype.setItem = function() {};
    isPrivate = true;
  };
};
    if(isPrivate){
    alert("您处于无痕浏览，请关闭无痕模式，并刷新页面");
    }
  //
</script>
